import { LinearGradient } from "expo-linear-gradient";
import { VStack } from "native-base";
import React from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
import styled from "styled-components/native";

import BannerImage from "@/components/atoms/BannerImage";
import Carousel from "@/components/molecules/Carousel";
import { StoreHighlight } from "@/interfaces/domain/StoreHighlight";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const cardWidth = 280;

type StoreHighlightListProps = {
  data: StoreHighlight[];
  isLoading: boolean;
  onSelect: (id: string) => void;
};

const StoreHighlightList = ({ data, isLoading, onSelect }: StoreHighlightListProps) => {
  const items = isLoading ? Array(4).fill(1) : data;
  return (
    <VStack>
      <Carousel
        data={items || []}
        itemLayout={cardWidth}
        showViewMoreButton={false}
        renderItem={({ item }) =>
          isLoading ? (
            <ShimmerCard />
          ) : (
            <BannerImage
              title={item?.descricao}
              width={cardWidth + "px"}
              imageUrl={item.foto_destaque}
              onPress={() => onSelect(item._id)}
            />
          )
        }
      />
    </VStack>
  );
};

const ShimmerCard = styled(ShimmerPlaceholder)`
  border-radius: 10px;
  width: ${cardWidth}px;
  height: 120px;
  margin: 10px;
`;

export default StoreHighlightList;
